import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';

import { TelerecourspnrSharedLibsModule } from './shared-libs.module';

import {ChangeExtension} from './pipes/extension-changer.pipe';
import {CaptchaService} from './components/captcha/captcha.service';
import {CguService} from './services/cgu.service';
import {ScrollToDirective} from './directives/scroll-to.directive';
import {ScrollToService} from './services/scroll-to.service';
import { ErrorService } from './services/error.service';
import { TrackingService } from './services/tracking.service';
import { NavigationService } from './services/navigation.service';
import { NavBackGuard } from './guards/nav-back.guard';
import { ParametersService } from './services/parameters.service';
import { LoginService } from '../account/authentication/login.service';
import { AccountService } from './services/account.service';
import { StateStorageService } from './services/state-storage.service';
import { UserService } from './services/user.service';
import { CSRFService } from './services/csrf.service';
import { AuthServerProvider } from './services/auth-session.service';
import { RouterAuthService } from './services/router-auth.service';
import {EventPieceService} from '../requete/historique-requete/timeline/timeline-element/event-piece.service';
import {RequeteService} from './services/requete.service';
import {DraftRequeteService} from './services/draft-requete.service';
import { TelerecourspnrSharedCommonModule } from './shared-common.module';
import {TRCAdminConfigService} from './services/trc-admin-config.service'

@NgModule({
    imports: [
        TelerecourspnrSharedLibsModule,
        TelerecourspnrSharedCommonModule,
        ReactiveFormsModule
    ],
    declarations: [
        ScrollToDirective,
        ChangeExtension
    ],
    providers: [
        LoginService,
        AccountService,
        StateStorageService,
        UserService,
        CSRFService,
        AuthServerProvider,
        RouterAuthService,
        CguService,
        ChangeExtension,
        CaptchaService,
        ScrollToService,
        ErrorService,
        TrackingService,
        NavigationService,
        ParametersService,
        NavBackGuard,
        EventPieceService,
        RequeteService,
        DraftRequeteService,
        TRCAdminConfigService
    ],
    exports: [
        TelerecourspnrSharedCommonModule,
        ScrollToDirective,
        ChangeExtension
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class TelerecourspnrSharedModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts